import React from "react";
import NavigationLink from "./NavigationLink";
import ContactDetails from "./ContactDetails";
import ContactProfileImage from "./ContactProfileImage";
import { observer } from "mobx-react";
import { connectoRoles } from "../../utils/constants";

const ConnectCard = ({
  item,
  setTab,
  photo,
  name,
  position,
  phoneNum,
  emailId,
  wrapperClass = "connect_card_outside",
}) => {
  return (
    <div className={wrapperClass}>
      <div className="connect_person_img">
        <ContactProfileImage
          photo={photo}
          name={name}
          position={connectoRoles[position]}
        />
        <NavigationLink item={item} position={connectoRoles[position]} />
      </div>

      <div className="contact-details-wrapper">
        <ContactDetails
          name={name}
          position={connectoRoles[position]}
          emailId={emailId}
          phoneNum={phoneNum}
        />
      </div>

      <div className="navigation-button-wrapper">
        <NavigationLink item={item} position={connectoRoles[position]} />
      </div>
    </div>
  );
};

export default observer(ConnectCard);
